import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { X } from "lucide-react";
import { buildSupportWhatsAppUrl } from "../../helpers/supportWhatsapp";

const WHATSAPP_MESSAGE =
  "¡Hola! Me gustaría recibir más información sobre Homelan.";

const href = buildSupportWhatsAppUrl(WHATSAPP_MESSAGE);

// Botón flotante de soporte: una sola píldora "¿Necesitas ayuda?", sin el
// botón redondo de WhatsApp (demasiado visto).
// Al abrirlo muestra una tarjeta con el acceso al chat de WhatsApp. Los
// estilos están en _design-system.scss (.hl-support).
const WhatsappWidget = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="hl-support">
      {open && (
        <div className="hl-support__panel animate__animated animate__fadeInUp animate__faster" role="dialog" aria-label="Soporte">
          <div className="hl-support__panel-header">
            <span className="hl-support__avatar" aria-hidden="true">
              <FontAwesomeIcon icon={faWhatsapp} size="lg" />
            </span>
            <div style={{ flex: 1 }}>
              <div className="font-weight-semi-bold">Equipo Homelan</div>
              <div className="hl-caption">Normalmente respondemos en minutos</div>
            </div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Cerrar"
              className="hl-icon-button"
              style={{ width: "2rem", height: "2rem", background: "var(--hl-surface-muted)" }}
            >
              <X size={16} strokeWidth={2} aria-hidden="true" />
            </button>
          </div>
          <div className="hl-support__panel-body">
            <div className="hl-support__bubble">
              👋 ¡Hola! ¿Tienes dudas sobre la gestión de tus propiedades? Escríbenos y te ayudamos al instante.
            </div>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-block text-white d-flex align-items-center justify-content-center"
              style={{ backgroundColor: "#25D366" }}
            >
              <FontAwesomeIcon icon={faWhatsapp} className="mr-2" size="lg" />
              Iniciar chat por WhatsApp
            </a>
          </div>
        </div>
      )}

      <button
        type="button"
        className="hl-support__pill"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        {open ? "Cerrar" : "¿Necesitas ayuda?"}
      </button>
    </div>
  );
};

export default WhatsappWidget;
